<template>
    <Link v-if="href" :href="href"
        class="text-sm md:text-base inline-flex shrink-0 items-center justify-center font-medium py-2 md:py-3 rounded-full transition-colors duration-100 ease-out cursor-pointer"
        :class="{
            'bg-gray-500 cursor-not-allowed text-white': disabled,
            'bg-regal-blue-700 cursor-pointer text-white hover:bg-regal-blue-800': !disabled && type == 'primary' || !disabled && !type ,
            'border border-gray-400 text-gray-800 hover:border-gray-600 hover:text-gray-900': !disabled && type == 'secondary',
        }
    ">
        <div v-if="!icon" class="px-6 md:px-10">
            {{ label }}
        </div>
        <div v-if="icon" class="flex items-center space-x-1.5 px-5 pr-6 shrink-0">
            <component v-if="icon" :is="icon" class="w-6 h-6"/>
            <div class="whitespace-nowrap">
                {{ label }}
            </div>
        </div>

    </Link>

    <div v-else
        class="text-sm md:text-base inline-flex shrink-0 items-center justify-center rounded-full transition-colors duration-100 ease-out cursor-pointer"
        :class="{
            'bg-gray-500 py-2 md:py-3 font-medium cursor-not-allowed text-white': disabled || type == 'busy',
            'bg-regal-blue-700 py-2 md:py-3 font-bold cursor-pointer text-white hover:bg-regal-blue-800 active:bg-regal-blue-900': !disabled && type == 'primary' || !disabled && !type ,
            'border-2 box-border py-2.5 font-bold border-regal-blue-700 cursor-pointer text-regal-blue-700 hover:border-regal-blue-400 hover:text-regal-blue-500 active:border-regal-blue-800 active:text-regal-blue-800': !disabled && type == 'primary outline',
            'border-2 box-border py-2.5 font-bold border-gray-400 text-gray-800 hover:border-gray-600 hover:text-gray-900 active:border-gray-800': !disabled && type == 'secondary',
            'border-2 box-border py-2.5 font-bold border-red-500 text-red-500 hover:border-red-600 hover:text-red-600 active:border-red-700 active:text-red-700': !disabled && type == 'danger outline',
            'font-bold text-white py-2 md:py-3 bg-red-500 hover:bg-red-600 active:bg-red-700': !disabled && type == 'danger',
        }
    ">
        <div v-if="!icon && type != 'busy'" class="px-6 md:px-10">
            {{ label }}
        </div>
        <div v-if="icon && type != 'busy'" class="flex items-center space-x-1.5 px-5 pr-6 shrink-0">
            <component v-if="icon" :is="icon" class="w-6 h-6"/>
            <div class="whitespace-nowrap">
                {{ label }}
            </div>
        </div>

        <div v-if="type == 'busy'" class="flex space-x-1.5 px-5 pr-6 items-center">
            <svg class="animate-spin h-5 w-5 mr-1 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <div class="">
                {{ label }}
            </div>
        </div>

    </div>
</template>

<script>
import {
    LightningBoltIcon,
    TrashIcon,
    UserAddIcon,
    LinkIcon,
    PencilIcon,
    BeakerIcon,
    ClipboardCopyIcon,
    CheckIcon,
    CloudUploadIcon,
    UploadIcon,
    CloudDownloadIcon,
    RefreshIcon
} from '@heroicons/vue/outline'

export default {
    components: {
        LightningBoltIcon,
        TrashIcon,
        UserAddIcon,
        LinkIcon,
        PencilIcon,
        BeakerIcon,
        ClipboardCopyIcon,
        CheckIcon,
        CloudUploadIcon,
        UploadIcon,
        CloudDownloadIcon,
        RefreshIcon
    },
    props: [ 'disabled', 'label', 'href', 'type', 'icon'],
}
</script>
